$('.custom_add_btn').click(function (e) {
  if ($(this).hasClass('addon_cart')) {
        let checkboxChecked = $('.additional_products input:checked').length > 0;

    if (!checkboxChecked) {
      return; // Exit the function if no checkboxes are checked
    }
        let jsonObj = [];
          e.preventDefault();

    $('.additional_products input:checked').each(function () {
      let id = $(this).val(); 
      let item = {
        id: parseInt(id), 
        quantity: 1 
      };

      jsonObj.push(item); 
    });

    console.log(jsonObj);

    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: { items: jsonObj },
      dataType: "json",
      success: function (data) {
        console.log(data);
        setTimeout(function(){
        $(".custom_atc button").trigger('click');
          },1000)
      },
      error: function () {
        console.error("Failed to add items to cart.");
      }
    });
  }
});
